import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {EulaPopupComponent} from './eula-popup/eula-popup.component';
import {EulaComponent} from './eula/eula.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {ButtonModule, CheckboxComponent} from '@adnova/jf-ng-components';
import {PrivacyPolicyContentModule} from '../privacy-policy-content/privacy-policy-content.module';


@NgModule({
  declarations: [
    EulaPopupComponent,
    EulaComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    ButtonModule,
    CheckboxComponent,
    PrivacyPolicyContentModule,
  ]
})
export class EulaModule {
}
